import { createSelector } from '@reduxjs/toolkit';
import { GlobalState } from '../rootReducer';
import { OPEN_WAITING_FOR_APPROVAL_MODAL } from './actions';

/* reducer */
export const DEFAULT_STATE = {
    catalogId: 0,
    hideUrgentMessages: false,
};

export type State = typeof DEFAULT_STATE;

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case OPEN_WAITING_FOR_APPROVAL_MODAL:
            return {
                ...state,
                catalogId: action.payload.catalogId,
                hideUrgentMessages: Boolean(action.payload?.hideUrgentMessages),
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.waitingForApproval;

export const getWaitingForApprovalCatalogId = createSelector(stateSelector, (state) => state.catalogId);

export const getHideUrgentMessages = createSelector(stateSelector, (state) => state.hideUrgentMessages);
